import { observer } from "mobx-react";
import Footer from "./Footer";

const Fullpage = observer(({ screen }) => {
  return (
    <div className="container-fluid px-0 mb-5">
      {screen}
      <Footer />
    </div>
  );
});
export default Fullpage;
